const Menu = [
  {
    title: "Dashboard",
    icon: "dashboard",
    href: "#/dashboard"
  },
  {
    title: "Users",
    icon: "person",
    items: [
      { title: "User List", href: "#/user/list" },
      { title: "Role List", href: "#/role/list" }
    ]
  },
  {
    title: "Setting",
    icon: "settings",
    items: [
      {
        title: "Form managerment",
        icon: "settings",
        items: [
          { title: "Workflow management 1", href: "#/workflow/list1" },
          { title: "Menu List 1", href: "#/menu/list1" }
        ]
      },
      { title: "Workflow management", href: "#/workflow/list" },
      { title: "Menu List", href: "#/menu/list" },
      {
        title: "WBLCategory List",
        href: "#/wbl-category/list"
      },
      {
        title: "WBL List",
        href: "#/wbl/list"
      },
      {
        title: "Dashboard Template",
        href: "#/dashboard-template"
      },
      {
        title: "Dashboard Widget",
        href: "#/dashboard-widget/list"
      },
      {
        title: "Map",
        href: "#/map"
      }
    ]
  }
];

export default Menu;
